import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useURLSync = (defaultFilters) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState(() => {
    const urlFilters = {};
    Object.keys(defaultFilters).forEach((key) => {
      urlFilters[key] = searchParams.get(key) || defaultFilters[key];
    });
    return urlFilters;
  });

  useEffect(() => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== defaultFilters[key]) {
        params.set(key, value);
      }
    });
    setSearchParams(params, { replace: true });
  }, [filters, setSearchParams]);

  return [filters, setFilters];
};
